module.exports = __webpack_public_path__ + "img/open_cmd_app_windows.edd374e3.png";